// The legacy system is a read-only archive after the move to the new Ship242 platform.
// The API enforces the freeze; this flag only keeps the UI from offering actions that would fail.
export const readOnly = process.env.VUE_APP_READ_ONLY === "true";

// Writes the API still accepts while frozen: login, and the logs report (a read sent as a POST).
const allowedWrites = [/^\/?authenticate$/, /^\/?logs$/];

// GET routes that mutate data on the legacy API.
const blockedReads = [
	/^\/?invoices\/[^/]+\/(approve|unapprove|pay)$/,
	/^\/?shipments\/[^/]+\/notify$/,
	/^\/?shipments\/parcels\/[^/]+\/notify$/,
	/^\/?shipment\/notifications\/reset$/,
	/^\/?forgot\/password/,
];

export function isBlockedRequest(method, url) {
	const path = (url || "").split("?")[0];
	const verb = (method || "get").toLowerCase();

	if (verb === "get" || verb === "head") {
		return blockedReads.some((pattern) => pattern.test(path));
	}

	return !(verb === "post" && allowedWrites.some((pattern) => pattern.test(path)));
}

// Pages whose only purpose is to change data.
export const writeOnlyRoutes = [
	"order.create",
	"order.edit",
	"packages.scan",
	"packages.in",
	"shipments.create",
	"shipments.edit",
	"checkout",
	"retail.index",
	"calculator",
	"register",
	"password.forget",
	"password.reset",
];
